import { useEffect, useState } from "react"
import { useApiStatus } from "./useApiStatus"

export const useRequestOnMount = (
    apiRequest,
    fetchFunction,
    { routeParams, body, queryParams } = {},
    onSuccess,
    onError
) => {
    const [initialLoadingHack, setInitialLoadingHack] = useState(true)

    useEffect(
        () => apiRequest(fetchFunction, routeParams, body, queryParams),
        []
    )

    useEffect(() => {
        setTimeout(() => setInitialLoadingHack(false), 500)
    }, [])

    useApiStatus(fetchFunction, null, false, onSuccess, onError)

    return { initialLoadingHack }
}
